// Plain data: no console, no loader (the entry chunk reads it; route.ts stays lazy).
/** Provider scopes this module serves in the service catalog (Manticore / Eagle); the CDN shell opens the service. */
export const serviceScopes = [{ scope: 'External.SwiftFederation', category: 'cdn' }] as const;
